import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const AppDownloadQR = () => {
  const REDIRECT_PAGE_URL = "https://zoo.alemtilsimat.com/link/install";

  return (
    <div style={styles.pageContainer}>
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-5px); }
            100% { transform: translateY(0px); }
          }
          .store-icon:hover {
            transform: scale(1.1);
            transition: transform 0.2s ease;
          }
        `}
      </style>

      <div style={styles.card}>
        <div style={styles.header}>
          <h2 style={styles.title}>Download Mobile App</h2>
          <p style={styles.subtitle}>
            Install our app for the best experience.
          </p>
        </div>

        <div style={styles.qrWrapperOuter}>
          <div style={styles.qrWrapperInner}>
            <QRCodeCanvas
              value={REDIRECT_PAGE_URL}
              size={220}
              level={"H"}
              bgColor={"#ffffff"}
              fgColor={"#2c3e50"} 
              includeMargin={true}
              style={{ borderRadius: '12px' }}
            />
          </div>
          <div style={styles.scanMeLabel}>SCAN ME</div>
        </div>

        <div style={styles.footer}>
          <p style={styles.instruction}>
            Open your camera and scan the code
          </p>
          
          <div style={styles.storeIcons}>
            <div  onClick={() => window.location.href = REDIRECT_PAGE_URL}  style={styles.iconBadge} className="store-icon" title="Android">
             <svg  width="24" height="24" viewBox="0 0 24 24" fill="#3DDC84">
  <path d="M6,18c0,0.55 0.45,1 1,1h1v3.5c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5L11,19h2v3.5c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5L16,19h1c0.55,0 1,-0.45 1,-1L18,8L6,8v10zM3.5,8C2.67,8 2,8.67 2,9.5v7c0,0.83 0.67,1.5 1.5,1.5S5,17.33 5,16.5v-7C5,8.67 4.33,8 3.5,8zM20.5,8c-0.83,0 -1.5,0.67 -1.5,1.5v7c0,0.83 0.67,1.5 1.5,1.5s1.5,-0.67 1.5,-1.5v-7c0,-0.83 -0.67,-1.5 -1.5,-1.5zM15.53,2.16l1.3,-1.3c0.2,-0.2 0.2,-0.51 0,-0.71 -0.2,-0.2 -0.51,-0.2 -0.71,0l-1.48,1.48C13.85,1.23 12.95,1 12,1c-0.96,0 -1.86,0.23 -2.66,0.63L7.85,0.15c-0.2,-0.2 -0.51,-0.2 -0.71,0 -0.2,0.2 -0.2,0.51 0,0.71l1.31,1.31C6.97,3.26 6,5.01 6,7h12c0,-1.99 -0.97,-3.75 -2.47,-4.84zM10,5L9,5L9,4h1v1zM15,5h-1L14,4h1v1z"/>
</svg>
            </div>

            <span style={styles.divider}>|</span>

            <div onClick={() => window.location.href = REDIRECT_PAGE_URL} style={styles.iconBadge} className="store-icon" title="iOS">
              <svg width="24" height="24" viewBox="0 0 384 512" fill="#333">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 52.3-11.4 69.5-34.3z"/>
              </svg>
            </div>
          </div>
          <p style={styles.smallNote}>iOS & Android Compatible</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#eff3f8',
    fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '24px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.08)',
    padding: '40px',
    maxWidth: '380px',
    width: '100%',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    animation: 'float 6s ease-in-out infinite' // Süzülme efekti
  },
  header: {
    marginBottom: '30px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1a1a1a',
    margin: '0 0 8px 0',
    letterSpacing: '-0.5px'
  },
  subtitle: {
    fontSize: '15px',
    color: '#666',
    margin: 0,
    lineHeight: '1.5'
  },
  qrWrapperOuter: {
    position: 'relative',
    padding: '15px',
    borderRadius: '20px',
    background: 'linear-gradient(145deg, #ffffff, #f0f0f0)',
    boxShadow: '5px 5px 15px #d1d9e6, -5px -5px 15px #ffffff',
    display: 'inline-block',
    marginBottom: '30px',
  },
  qrWrapperInner: {
    border: '1px solid rgba(0,0,0,0.05)',
    borderRadius: '12px',
    overflow: 'hidden',
  },
  scanMeLabel: {
    position: 'absolute',
    bottom: '-12px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#3b82f6', // Mavi
    color: 'white',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '11px',
    fontWeight: 'bold',
    letterSpacing: '1px',
    boxShadow: '0 4px 6px rgba(59, 130, 246, 0.3)'
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  instruction: {
    fontSize: '14px',
    color: '#888',
    marginBottom: '15px',
    fontWeight: '500'
  },
  storeIcons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '10px'
  },
  iconBadge: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    backgroundColor: '#f5f7fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#333'
  },
  divider: {
    color: '#ddd',
    fontSize: '20px',
    fontWeight: '300'
  },
  smallNote: {
    fontSize: '12px',
    color: '#999',
    marginTop: '5px'
  }
};

export default AppDownloadQR;